<upp-kb-textarea #input 
    [ngClass]="{ 'title': (value !== null) }"
    [ngStyle]="{ 'margin-bottom': formControl?.errors ? '15px' : '0px' }"
    [kiosk]="kiosk" 
    [rows]="rows"
    [name]="formControlName" 
    [placeholder]="placeholder" 
    [value]="value" 
    [readonly]="readonly"      
    [disabled]="_disabled" 
    (Focused)="onFocus()" 
    (Changed)="value = $event"
    [autocomplete]="autocomplete">
</upp-kb-textarea>
<ion-label class="input-title" [ngClass]="{ 'hide': !showTitle }">{{viewTitle}}</ion-label>
<upp-er-textarea *ngIf="formGroup"
    [form]="formGroup"
    [name]="formControlName" 
    [value]="value"
    [errornfo]="errornfo">
</upp-er-textarea>
